function matchesReferralSensitivity(serviceType, forwardReferralParams) {
  if (forwardReferralParams?.referralType === 'inbound') {
    if (forwardReferralParams.sensitive) {
      return serviceType.is_sensitive;
    }
    return !serviceType.is_sensitive;
  }
  // Everything is selectable by default
  return true;
}
export default matchesReferralSensitivity;
//# sourceMappingURL=matchesReferralSensitivity.js.map